export default __webpack_public_path__ + "6a996f6c159727961cf85c113bab4e4c.svg";